import React from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import AppInputNew from "../../Core/AppInput/AppInputNew";
import AppIcon from "@/components/Core/AppIcon/AppIcon";
import { chartColors } from "@/theme/chartColors";

export interface MonthlyGuaranteedHoursTableProps {
	control: Control<any>;
	errors: FieldErrors;
	onCopyToAll: () => void;
}

const MONTHS = [
	{ key: 1, label: "Jan" },
	{ key: 2, label: "Feb" },
	{ key: 3, label: "Mar" },
	{ key: 4, label: "Apr" },
	{ key: 5, label: "Maj" },
	{ key: 6, label: "Jun" },
	{ key: 7, label: "Jul" },
	{ key: 8, label: "Aug" },
	{ key: 9, label: "Sep" },
	{ key: 10, label: "Okt" },
	{ key: 11, label: "Nov" },
	{ key: 12, label: "Dec" },
];

const MonthlyGuaranteedHoursTable: React.FC<MonthlyGuaranteedHoursTableProps> = ({
	control,
	errors,
	onCopyToAll,
}) => {
	return (
		<div className="w-full">
			<div className="grid grid-cols-2 gap-2">
				{MONTHS.map((month, i) => (
					<div key={month.key} className="flex items-center gap-4">
						<div className="min-w-14 font-medium flex items-center">
							{month.label}
							{i === 0 && <AppIcon icon="copy" onClick={onCopyToAll} color={chartColors.action} />}
						</div>
						<Controller
							control={control}
							name={`guaranteedHoursByMonth.${month.key}`}
							render={({ field }) => (
								<AppInputNew
									{...field}
									placeholder="0-180"
									type="number"
									min={0}
									max={180}
									step="1"
									errors={(errors?.guaranteedHoursByMonth as any)?.[month.key]?.message}
									value={field.value ?? ""}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
										const val = e.target.value;
										field.onChange(val === "" ? undefined : Number(val));
									}}
									selectOnFocus
									containerClassName="max-w-24"
								/>
							)}
						/>
						<div>h</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default MonthlyGuaranteedHoursTable;
